import BaseStore from '@/store/base-store'

const options = {
  actions: {
    clear ({ commit }) {
      commit('item', {})
    }
  }
}
export default new BaseStore('machineries', options)



// WEBPACK FOOTER //
// ./src/store/modules/machineries.store.js